function LoginPage() {
    /**
     *
     */
    LoginPage.prototype.initialize = function (console) {
        this.console = console;
        this.id = "login";

        return this;
    };

    /**
     *
     */
    LoginPage.prototype.show = function () {
        var deferred = $.Deferred();

        if (window.localStorage["thing-it.account"] != undefined && window.localStorage["thing-it.password"] != undefined &&
            window.localStorage["thing-it.account"] != "" && window.localStorage["thing-it.password"] != "") {
            this.account = window.localStorage["thing-it.account"];
            this.password = window.localStorage["thing-it.password"];

            this.rememberMe = true;
            this.loggedInBefore = true;
        }
        else {
            this.rememberMe = false;
        }

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    LoginPage.prototype.leave = function () {
    };

    /**
     *
     */
    LoginPage.prototype.login = function () {
        if (this.rememberMe) {
            window.localStorage["thing-it.account"] = this.account;
            window.localStorage["thing-it.password"] = this.password;
        } else {
            window.localStorage["thing-it.account"] = "";
            window.localStorage["thing-it.password"] = "";
        }

        this.console.login({account: this.account, password: this.password});
    };

    /**
     *
     */
    LoginPage.prototype.changePasswordAndLogin = function () {
        this.messages = [];

        if (this.newPassword && this.passwordConfirmation && this.newPassword.localeCompare(this.passwordConfirmation) != 0) {
            this.messages.push({
                label: "New Password and Password Confirmation must be equal."
            });
        }

        if (this.messages.length == 0) {

            if (this.rememberMe) {
                window.localStorage["thing-it.account"] = this.account;
                window.localStorage["thing-it.password"] = this.newPassword;
            } else {
                window.localStorage["thing-it.account"] = "";
                window.localStorage["thing-it.password"] = "";
            }

            this.console.changePasswordAndLogin(this.account, this.password, this.newPassword);
        }
    };

    /**
     *
     */
    LoginPage.prototype.registerUser = function () {
        this.messages = [];

        if (this.password && this.passwordConfirmation && this.password.localeCompare(this.passwordConfirmation) != 0) {
            this.messages.push({
                label: "Password and Password Confirmation must be equal."
            });
        }

        if (this.messages.length == 0) {
            this.console.consoleService.registerUser(this.account, this.password,
                this.firstName,
                this.lastName).done(function () {
                    this.newUser = false;
                    this.console.openMessageDialog("You have successfully registered, " + this.firstName + " " + this.lastName + ". " +
                        "Now check your Inbox - and possibly Spam Folders - for your registration confirmation.");
                }.bind(this)).fail(function (error) {
                    this.console.consoleService.logError(error);
                    this.console.openMessageDialog("Sorry, " + this.firstName + " " + this.lastName + ". We could not register you: " + error, "error");
                }.bind(this));
        }
    };
}
